module.exports = __webpack_public_path__ + "img/elo-dark.1e296118.svg";